import React from 'react';

import AccordionBody from './AccordionBody';
import AccordionHeader from './AccordionHeader';
import BenefitsCard from 'components/layouts/Preferences/Benefits/BenefitsCard';

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded
    };
  }

  toggleExpand = () => {
    this.setState((prevState) => ({ expanded: !prevState.expanded }));
  };

  render() {
    const { expanded } = this.state;
    const { alwaysOpen, title, headerChildren, bodyChildren } = this.props;

    return (
      <BenefitsCard>
        <AccordionHeader
          expanded={expanded}
          alwaysOpen={alwaysOpen}
          title={title}
          toggle={this.toggleExpand}
        >
          {headerChildren}
        </AccordionHeader>
        <AccordionBody expanded={alwaysOpen || expanded}>
          {bodyChildren}
        </AccordionBody>
      </BenefitsCard>
    );
  }
}

export default Accordion;
